import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { TitleCasePipe } from "@angular/common";
import { LazyLoadEvent } from "primeng/api";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver/src/FileSaver";
import * as moment from "moment";
import { CountryService } from "../country/service/country.service";
import { StateService } from "../state/service/state.service";
import { CityService } from "../city/service/city.service";
import { CategoryService } from "src/app/services/category.service";
import { ReportService } from "src/app/services/report.service";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Table } from "primeng/table";

@Component({
  selector: 'app-revenue',
  templateUrl: './revenue.component.html',
  styleUrls: ['./revenue.component.scss'],
  providers: [MessageService, ConfirmationService, TitleCasePipe]
})

export class RevenueComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  errorMessage = "";
  searchBy: any[];
  totalRecords: 0;
  loading: boolean;
  paginationOption;
  public lastTableLazyLoadEvent: LazyLoadEvent;
  @ViewChild("dt", { static: false }) public dt: Table;
  yearRange;
  minYear = environment.minYear;
  startDate: Date;
  endDate: Date;
  downloadFlg: boolean;
  downloadActiveUserReportList: any;
  searchby;
  public hide: boolean = true;
  sportList: any;
  countrylist: any[];
  stateList: any[];
  cityList: any[];
  countryCode: string;
  country: any;
  state: any;
  cityName: any;
  sportName: any;
  revenueReportsData: any;
  
  constructor(
    private countryService: CountryService,
    private stateService: StateService,
    private cityService: CityService,
    private categoryService: CategoryService,
    private reportService: ReportService
  ) {}

  ngOnInit() {
    this.paginationOption = environment.pagination;
    this.searchBy = [
      { label: 'Created On', value: "created_at" }
    ];
    this.searchby = this.searchBy[0];
    this.downloadFlg = false;
    this.getCountries();
    this.getSportList();
  }

  getSportList() {
    const query = `?filterByDisable=false&getSubcategory=true&pageSize=10&pageNumber=1&filterByParentCategory=Sport`;
    this.categoryService.getCategoryWithoutAuthList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
        this.sportList = data?.data?.items;
    }, err => {
        this.errorMessage = err.error.message;
    })
  }

  getCountries() {
    this.countrylist = [];
    this.stateList = [];
    this.cityList = [];
    let query = "filterByDisable=false&filterByStatus=true";
    this.countryService.getcountryList(query).pipe(takeUntil(this.destroy$)).subscribe(
      data => {
        if (data.data.items.length > 0) {
          data.data.items.forEach(element => {
            let countryObj = {
              name: element.name,
              iso2: element.iso2,
            }
            this.countrylist.push(countryObj);
          });
        }
      },
      err => {
        this.errorMessage = err.error.message;
      }
    );
  }

  getStates(event) {
    this.stateList = [];
    this.cityList = [];
    this.state = null;
    this.cityName = null;
    if (event.value !== null) {
      let countryCode = event.value.iso2;
      let query = "filterByDisable=false&orderBy=name&sortBy=1&filterByCountryCode=" + countryCode;
      this.stateService.getstateList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
  
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let stateObj = {
              name: element.name,
              id: element.id,
            }
            this.stateList.push(stateObj);
          });
        }
      })
    }
    this.loadRevenueReport(this.lastTableLazyLoadEvent);
  }

  async getCities(event) {
    this.cityList = [];
    this.cityName = null;
    if (event.value !== null) {
      const stateCode = event.value.id;
      let query = "?filterByStatus=true&filterByDisable=false&orderBy=name&sortBy=1&filterByStateId=" + stateCode;
      this.cityService.getcityList(query).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        if (res.data.items.length > 0) {
          res.data.items.forEach(element => {
            let cityObj = {
              name: element.name,
              code: element.name,
            }
            this.cityList.push(cityObj);
          });
        }
      })
    }
    this.loadRevenueReport(this.lastTableLazyLoadEvent);
  }

  clear() {
    this.startDate = null;
    this.endDate = null;
    this.searchby = this.searchBy[0];
    this.stateList = [];
    this.cityList = [];
    this.country = null;
    this.state = null;
    this.cityName = null;
    this.sportName = null;
    const resetEvent = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0, filters: {} });
    if (this.dt) {
      this.dt.filters = {};
      this.dt.first = 0;
    }
    this.loadRevenueReport(resetEvent);
  }

  applySportFilter() {
    if (this.dt) {
      this.dt.first = 0;
    }
    const event = Object.assign({}, this.lastTableLazyLoadEvent, { first: 0 });
    this.loadRevenueReport(event);
  }

  loadRevenueReport(event: LazyLoadEvent) {
    event = event || {} as LazyLoadEvent;
    this.lastTableLazyLoadEvent = event;
    var query = "?filterByDisable=false";
    var pagenumber = 1;
    var params = "";
    var rows;
    if (event.first != undefined && event.first == 0) {
      pagenumber = event.first + 1;
    } else if (event.first != undefined && event.first > 0) {
      pagenumber = event.first / event.rows + 1;
    } else {
      pagenumber = 1;
    }
    if (event.rows != undefined) {
      rows = event.rows;
    } else {
      rows = 10;
    }

    if (this.searchby) {
      params += "&filterByDate=" + this.searchby.value;
    }

    if (this.startDate) {
      params +=
        "&filterByStartDate=" + moment(this.startDate).format("YYYY-MM-DD");
    }

    if (this.endDate) {
      params += "&filterByEndDate=" + moment(this.endDate).format("YYYY-MM-DD");
    }

    if (this.country) {
      params += "&filterByCountry=" + this.country.name;
    }

    if (this.state) {
      params += "&filterByState=" + this.state.name;
    }

    if (this.cityName) {
      params += "&filterByCity=" + this.cityName;
    }

    if (this.sportName) {
      params += "&filterBySportwise=" + encodeURIComponent(this.sportName);
    }

    const getFilterValue = (field) => {
      if (event.filters != undefined && event.filters[field] != undefined && event.filters[field].value !== undefined && event.filters[field].value !== null && event.filters[field].value !== "") {
        return event.filters[field].value;
      }
      return null;
    };
    const columnFilters = [
      { field: "city", parameter: "filterByRevenueCity" },
      { field: "state", parameter: "filterByRevenueState" },
      { field: "country", parameter: "filterByRevenueCountry" },
      { field: "academySubscriptionFee", parameter: "filterByAcademySubscriptionFee" },
      { field: "userSubscriptionFee", parameter: "filterByUserSubscriptionFee" },
      { field: "tournamentRegistrations", parameter: "filterByTournamentRegistrations" },
      { field: "courtBookings", parameter: "filterByCourtBookings" },
      { field: "academyRegistration", parameter: "filterByAcademyRegistration" },
      { field: "findAPartner", parameter: "filterByFindAPartner" },
      { field: "eStore", parameter: "filterByEStore" },
      { field: "totalRevenue", parameter: "filterByTotalRevenue" },
    ];

    columnFilters.forEach(columnFilter => {
      const value = getFilterValue(columnFilter.field);
      if (value !== null) {
        params += "&" + columnFilter.parameter + "=" + encodeURIComponent(String(value));
      }
    });

    // at the time of download hide pagination option
    if (this.downloadFlg == false) {
      if (params != undefined && params != "") {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber + params;
      } else {
        query += "&pageSize=" + rows + "&pageNumber=" + pagenumber;
      }
    } else {
      if (params != undefined && params != "") {
        query += params;
      }
    }

    if (event.sortField != undefined && event.sortOrder != undefined) {
      var orderBy = "";
      if (event.sortOrder == 1) {
        orderBy = "ASC";
      } else {
        orderBy = "DESC";
      }
      query += "&sortBy=" + event.sortField + "&orderBy=" + orderBy;
    }
    this.reportService.getRevenueReport(query).pipe(takeUntil(this.destroy$)).subscribe(
      (data:any) => {
        console.log('data : ',data);
         if (this.downloadFlg === false) {
          this.revenueReportsData = data.data;
          this.totalRecords = data.totalCount;
        } else {
          this.exportRevenueReportListData(data.data);
          this.downloadFlg = false;
        }
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }

  setDownloadFlag() {
    this.downloadFlg = false;
  }

  exportExcel() {
    this.downloadFlg = true;
    this.loadRevenueReport(this.lastTableLazyLoadEvent);
  }

  async exportRevenueReportListData(activeUserReportList) {
    this.downloadActiveUserReportList = activeUserReportList;
    const columnMapping = {
      city: "City",
      state: "State",
      country: "Country",
      academySubscriptionFee: "Academy Subscription Fee",
      userSubscriptionFee: "User Subscription Fee",
      tournamentRegistrations: "Tournament Registrations",
      courtBookings: "Court Bookings",
      academyRegistration: "Academy Registration",
      findAPartner: "Find A Partner",
      eStore: "E Store",
      totalRevenue: "Total Revenue",
      totalGstAmount: "Total GST Amount",
      payouts: "Payouts",
      tplShare: "TPL Share",
    };
    const columns = Object.keys(columnMapping);
    const headers = Object.values(columnMapping);

    import("exceljs").then(({ Workbook }) => {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("data");
      const headerRow = worksheet.addRow(headers);
      headerRow.eachCell(cell => {
        cell.font = { bold: true };
      });

      this.downloadActiveUserReportList.forEach(item => {
        worksheet.addRow(columns.map(column => (
          item[column] !== undefined && item[column] !== null ? item[column] : ""
        )));
      });

      workbook.xlsx.writeBuffer().then((buffer: ArrayBuffer) => {
        this.saveAsExcelFile(buffer, "Revenue_Report");
      });
    });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      let filename;
      filename = fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION;
      saveAs(data, filename);
    });
  }

  /**
   * Use to add more columns in the table.
   */
  addColumns() {
    this.hide = false;
  }

  /**
   * Use to remove more columns in the table.
   */
  removeColumns() {
    this.hide = true;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
